import * as React from 'react'
import { Base64 } from 'js-base64'

import { openWindow } from '../../Util'

import './index.css'

class Menu extends React.Component {
  
  handleSwitchPanoClk = () => {
    let { toggleScroll } = this.props
    toggleScroll()
  }

  handleNavShopClk = () => {
    let { sellerId } = this.props
    openWindow(`//shop.m.taobao.com/shop/shop_index.htm?userId=${sellerId}&shop_navi=dongtai`)
  }

  handleNavWangWangClk = () => {
    let { sellerNick } = this.props
    openWindow(`//h5.m.taobao.com/ww/index.htm#!dialog-${Base64.encode(sellerNick)}`)
  }

  render() {
    let { scrollVisible } = this.props
    return (
      <ul className={`menu container ${!scrollVisible ? 'active' : ''}`}>
        <li className="item" onClick={this.handleSwitchPanoClk}>
          <img className="icon" src="//img.alicdn.com/tfs/TB16Y5xaKSSBuNjy0FlXXbBpVXa-48-48.png" alt="exchange pos" />
          <span className="label">切换位置</span>
        </li>
        <li className="item" onClick={this.handleNavWangWangClk}>
          <img className="icon" src="//img.alicdn.com/tfs/TB1oaKCaL1TBuNjy0FjXXajyXXa-48-48.png" alt="wangwang" />
          <span className="label">旺旺</span>
        </li>
        <li className="item" onClick={this.handleNavShopClk}>
          <img className="icon" src="//img.alicdn.com/tfs/TB12r5xaKSSBuNjy0FlXXbBpVXa-48-48.png" alt="shop" />
          <span className="label">店铺</span>
        </li>
      </ul>
    )
  }
}

export default Menu



// WEBPACK FOOTER //
// ./src/Components/Menu/index.js